export const ALERT_TYPES = Object.freeze({
  DEVICE: "DEVICE",
  NPS: "NPS",
  REFERRAL: "REFERRAL",
});
